import { IAction } from '@/redux/actions/action-helpers'
import { SelectedDocumentsForTrip } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

export function selectedDocumentsForTripsReducer(
	state: ApplicationState['selectedDocumentsForTrips'] = {},
	action: IAction,
) {
	switch (action.type) {
		case SelectedDocumentsForTrip.SetSelectedDocuments:
			return { ...state, ...action.payload }
	}

	return state
}
